import "../styles/not-found.scss";

const NotFound = () => {
  return (
    <div className="ai404">
      <div className="ai404__code">404</div>
      <div className="ai404__message">
        🤖 AI Response: This page does not exist in this dimension.
      </div>
      <a href="/" className="ai404__link">
        Return to safety
      </a>
    </div>
  );
};

export default NotFound;
